import { computed, unref, type MaybeRef } from 'vue'
import { createQuery } from '@/queries'
import {
  getPopularBrands,
  type PopularBrandsQuery,
} from '@/features/brands/api/brands'
import type { AxiosResponse } from 'axios'
import type { PopularBrandsResponse } from '@/types/brands'

type PopularBrandsResponseData = Awaited<
  ReturnType<typeof getPopularBrands>
> extends AxiosResponse<infer T>
  ? T
  : never

export const usePopularBrandsQuery = (
  payload: MaybeRef<PopularBrandsQuery>,
) => {
  return createQuery<PopularBrandsResponseData>({
    key: computed(() => {
      const value = unref(payload)
      return [
        'brands',
        'popular',
        value.page_num,
        value.page_size,
        value.audience ?? null,
      ] as const
    }),
    fetcher: async () => {
      const value = unref(payload)
      const response = await getPopularBrands(value)
      return response.data
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  })
}

export type { PopularBrandsResponse }
